var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSustainabilityEmission = function SvgSustainabilityEmission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8h3.429V16H0zM6.4 0h3.2v16H6.4zm6.4 9.143H16V16h-3.2z"
  })));
};
export { SvgSustainabilityEmission as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNC44SDMuNDI4NTdWMTZIMFY0LjhaTTYuNCAwSDkuNlYxNkg2LjRWMFpNMTIuOCA5LjE0Mjg2SDE2VjE2SDEyLjhWOS4xNDI4NloiLz4KPC9zdmc+Cg==";